export type AppEnv = "production" | "staging";

const PROD_DOMAIN = "www.mysiponline.com";

export function getAppEnv(): AppEnv {
  if (typeof window === "undefined") { 
    return "staging";
  }

  const host = window.location.host;

  return host === PROD_DOMAIN ? "production" : "staging";
}

export function isProduction(): boolean {
  return getAppEnv() === "production";
}
